/*
 * @Author: <pcjser> 
 * @Date: 2018-04-17 19:21:20 
 * @Last Modified by: pcjser
 * @Last Modified time: 2018-06-05 15:42:45
 */
import React, { Component, Fragment } from 'react';
import { HashRouter, Route, Switch, Redirect } from 'react-router-dom';
import Loadable from 'react-loadable';
import Loading from './components/Loading';
import NoMatch from './components/NoMatch';
import MainNav from './components/MainNav';

class Routes extends Component {
  render() {
    return (
      <HashRouter>
        <Fragment>
          <Route path="/" render={
            props => {
              let navShow = true
              let pathname = props.location.pathname;
              if (pathname.indexOf('/login') > -1 || pathname.indexOf('/result') > -1 || pathname.indexOf('/store') > -1 || pathname.indexOf('/simple') > -1) navShow = false
              let c = navShow ? <MainNav></MainNav> : null
              return c
            }
          } />
          <Switch>
            <Redirect exact from='/' to='/gameCenter'></Redirect>
            <Route path="/gameCenter" component={
              Loadable({
                loader: () => import('./containers/GameCenter'),
                loading: Loading
              })
            } />
            <Route path="/login" component={
              Loadable({
                loader: () => import('./containers/Login'),
                loading: Loading
              })
            } />
            <PrivateRoute exact path="/gameCharge" component={
              Loadable({
                loader: () => import('./containers/GameCharge'),
                loading: Loading
              })
            } />
            <PrivateRoute path="/gameCharge/charge/:gameId/:channel?" component={
              Loadable({
                loader: () => import('./containers/Charge'),
                loading: Loading
              })
            } />
            <PrivateRoute path="/gameCharge/pay" component={
              Loadable({
                loader: () => import('./containers/Pay'),
                loading: Loading
              })
            } />
            <PrivateRoute exact path="/simple/:gameId/:channel?" component={
              Loadable({
                loader: () => import('./containers/Simple'),
                loading: Loading
              })
            } />
            <PrivateRoute path="/vipCenter" component={
              Loadable({
                loader: () => import('./containers/VIPCenter'),
                loading: Loading
              })
            } />
            <PrivateRoute path="/result/:channel?" component={
              Loadable({
                loader: () => import('./containers/Result'),
                loading: Loading
              })
            } />
            <PrivateRoute exact path="/store" component={
              Loadable({
                loader: () => import('./containers/Store'),
                loading: Loading
              })
            } />
            <PrivateRoute path="/store/treasure" component={
              Loadable({
                loader: () => import('./containers/Treasure'),
                loading: Loading
              })
            } />
            <PrivateRoute path="/store/exchange" component={
              Loadable({
                loader: () => import('./containers/Exchange'),
                loading: Loading
              })
            } />
            <PrivateRoute path="/store/goods/:goodsId" component={
              Loadable({
                loader: () => import('./containers/Goods'),
                loading: Loading
              })
            } />
            <PrivateRoute path="/store/order/:orderId" component={
              Loadable({
                loader: () => import('./containers/Order'),
                loading: Loading
              })
            } />
            <PrivateRoute path="/store/address" component={
              Loadable({
                loader: () => import('./containers/Address'),
                loading: Loading
              })
            } />
            <Route component={NoMatch} />
          </Switch>
        </Fragment>
      </HashRouter>
    )
  }
}

const PrivateRoute = ({ component: Component, ...rest }) => {
  let username = window.localStorage.getItem('fw-username')
  let isLogin = false
  if (username) {
    isLogin = true
  }
  return <Route {...rest} render={props => (
    isLogin ?
      <Component {...props} />
      :
      <Mylogin />
  )
  }
  />
}

class Mylogin extends Component {
  componentWillMount() {
    window.localStorage.setItem('fw-loginBackUrl', window.location.href)
  }
  render() {
    return <Redirect to='/login'></Redirect>
  }
}

export default Routes


// WEBPACK FOOTER //
// ./src/route.jsx